import React from 'react';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  StyledWordsSlider,
  StyledWordsSliderWrapper,
  StyledWordsPicker,
  StyledSlider,
  StyledSliderArrow,
} from '../Styled';
import { LeftArrow, RightArrow } from '../../assets/icons/Arrows';

interface IWordsSlider {
  partOfSpeech: string;
  children: JSX.Element[];
}

// Slick doesn't have types for props
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SliderArrow = (props: any) => {
  const { className, style, onClick, isRotated } = props;
  const handleKeyDown = (event: React.KeyboardEvent) => {
    const { key } = event;
    if (key == 'Enter' || key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <StyledSliderArrow
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={className}
      style={style}
    >
      <div>{!isRotated ? <RightArrow /> : <LeftArrow />}</div>
    </StyledSliderArrow>
  );
};

export const WordsSlider: React.FC<IWordsSlider> = (props): JSX.Element => {
  const { partOfSpeech, children } = props;

  const settings = {
    dots: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    infinite: true,
    variableWidth: true,
    centerPadding: 20,

    nextArrow: <SliderArrow isRotated={false} />,
    prevArrow: <SliderArrow isRotated={true} />,
  };

  return (
    <StyledWordsSliderWrapper data-testid={`suggested-${partOfSpeech}-words-list`}>
      {children.length < 9 && children.length > 0 ? (
        <StyledWordsPicker> {children} </StyledWordsPicker>
      ) : (
        <StyledWordsSlider>
          <StyledSlider {...settings}>{children}</StyledSlider>
        </StyledWordsSlider>
      )}
    </StyledWordsSliderWrapper>
  );
};
